// @flow

export default class User {
  /**
   * Notify the user of the website
   */
  static notify(type: string, title: string, message: string): void {
    if (!window.notification) {
      throw new Error('Notification is not ready to send');
    }

    window.notification.notify({ type, title, message });
  }

  /**
   * Notify a success message to the user of the website
   */
  static notifySuccess(message: string): void {
    User.notify('success', window.store.getTranslation('notification.success.title'), message);
  }

  /**
   * Notify a error message to the user of the website
   */
  static notifyFail(message?: string, title?: string): void {
    if (!message) {
      message = window.store.getTranslation('Something went wrong');
    }

    if (!title) {
      title = window.store.getTranslation('notification.error.title');
    }

    User.notify('error', title, message);
  }
}
